import { render, staticRenderFns } from "./TakePictureModal.vue?vue&type=template&id=4f6473f2&scoped=true&"
import script from "./TakePictureModal.vue?vue&type=script&lang=js&"
export * from "./TakePictureModal.vue?vue&type=script&lang=js&"
import style0 from "./TakePictureModal.vue?vue&type=style&index=0&id=4f6473f2&prod&lang=scss&"
import style1 from "./TakePictureModal.vue?vue&type=style&index=1&id=4f6473f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6473f2",
  null
  
)

export default component.exports